import React from 'react';
import './CustomDatePicker.css';
import PropTypes from 'prop-types'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Calendar from "../../assets/admin/modules/calendar.svg";
export default function CustomDatePicker({ selected, placeholder, onChange, className, varient, maxDate, selectsStart, handlePrevDay, handleNextDay }) {

    return (
        <div className={`custom-date-picker ${[varient]}`}>
            <img src={Calendar} alt="Calendar" className="calendar-icon" />
            <DatePicker
                className={`customDatePicker ${className}`}
                selected={selected}
                placeholder={placeholder}
                onChange={onChange}
                autoComplete="off"
                maxDate={maxDate}
                selectsStart={selectsStart }
            />
            <div className="date-button-wrapper">
                <button onClick={handlePrevDay}>
                    <span className="material-symbols-rounded prev-date-icon">
                        chevron_left
                    </span>
                </button>
                <button onClick={handleNextDay}>
                    <span className="material-symbols-rounded">
                        chevron_right
                    </span>
                </button>
            </div>
        </div>
    );
}

CustomDatePicker.propTypes = {
    className: PropTypes.string,
    placeholder: PropTypes.string,
    selected: PropTypes.any,
    onChange: PropTypes.func,
    varient: PropTypes.string,
    maxDate: PropTypes.any,
    selectsStart: PropTypes.any,
    handlePrevDay: PropTypes.func,
    handleNextDay: PropTypes.func,
}